<template>
  <div>
    <p class="save-the-date-layout__description step__text">
      <b>Como editar:</b>
    </p>
    <div class="step" v-for="(step, index) in stepsOfEdition" :key="index">
      <p class="step__text">
        <b>{{ step.step }}</b>
      </p>
      <p class="step__text">{{ step.text }}</p>
    </div>

    <p class="save-the-date-layout__description step__text">
      <b>Dicas:</b>
    </p>
    <ul class="save-the-date-layout__dicas">
      <li>
        Caso seja necessário reposicionar alguma caixa de texto, você pode
        arrastá-la enquanto estiver selecionada.
      </li>
      <li>
        Caso não deseje que apareça alguma das informações, é só apagar o texto
        e deixar a caixa em branco.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stepsOfEdition: [
        {
          step: '01',
          text: 'Clique duas vezes sobre a caixa de texto que deseja editar para selecioná-la.',
        },
        {
          step: '02',
          text: 'Edite o texto dentro da caixa de texto preenchendo-a com o dado do seu casamento.',
        },
        {
          step: '03',
          text: 'Após editar todas as caixas de texto com os dados do seu casamento, clique no botão “Download” para salvar a imagem em seu dispositivo.',
        },
        {
          step: '04',
          text: 'Pronto, agora é só compartilhar com seus convidados como quiser! :)',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.steps-descriptions {
  padding-left: auto;
  text-align: center;

  @media (min-width: 768px) {
    padding-left: 30px;
    text-align: left;
  }

  @media (min-width: 992px) {
    padding-left: 65px;
  }

  a {
    button {
      margin-bottom: 45px;
    }
  }
}
.step {
  margin-bottom: 32px;
  &__text {
    text-align: left;
  }
}
</style>
